<template>
  <div class="flex flex-col w-full h-full">
    <Header />

    <div class="flex flex-col w-full flex-1-0-auto">
      <a id="focusResetAnchor" tabindex="-1" class="hidden" />
      <RouterView :key="$route.fullPath" />
    </div>

    <LostConnectionPopup />
    <SessionPopup />

    <Footer />
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

import Header from '~app/psp/brussels/header.vue'
import Footer from '~app/psp/brussels/footer.vue'
import LostConnectionPopup from '~app/psp/brussels/lost-connection-popup.vue'
import SessionPopup from '~app/psp/brussels/session-popup.vue'

export default Vue.extend({
  components: {
    Header,
    Footer,
    LostConnectionPopup,
    SessionPopup,
  },
})
</script>
